import { render, staticRenderFns } from "./lp-grand-test.vue?vue&type=template&id=6c016e74&scoped=true&"
import script from "./lp-grand-test.vue?vue&type=script&lang=js&"
export * from "./lp-grand-test.vue?vue&type=script&lang=js&"
import style0 from "./lp-grand-test.vue?vue&type=style&index=0&id=6c016e74&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c016e74",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/app/components/Logo.vue').default,Button: require('/app/components/Button.vue').default,Header: require('/app/components/Header.vue').default,NetworkForm: require('/app/components/NetworkForm.vue').default,SliderTestimonial: require('/app/components/SliderTestimonial.vue').default,Faq: require('/app/components/Faq.vue').default,Footer: require('/app/components/Footer.vue').default})
